import { create } from "zustand";

interface IdefaultValues {
  id: number | string;
  data: Record<string, any>;
}

const defaultValues: IdefaultValues = {
  id: "",
  data: {},
};

interface IuseEditV2PlanModel {
  onOpen: ({ id, data }: IdefaultValues) => void;
  onClose: () => void;
  initialValues: IdefaultValues;
}

export const useEditV2PlanModel = create<IuseEditV2PlanModel>((set) => ({
  initialValues: defaultValues,
  onOpen: ({ id, data }: IdefaultValues) =>
    set({ initialValues: { id, data } }),
  onClose: () => set({ initialValues: defaultValues }),
}));
